import { getProjectsData, saveProjectsData } from "./storage";

import { updateNested, deleteNested } from "../helpers";
import { LayerAlias, UnitTypes } from "constant";
import {
  ChangeSeparateProjectValueInterface,
  ChangeStorageDataInterface,
  DeleteNestedParamInterface,
  ProjectDataInterface,
  ProjectParamsInterface,
  UpdateNestedParamInterface
} from "./interfaces";

export const getProject = ({
  projectId
}: ProjectParamsInterface): ProjectDataInterface | {} => {
  const projectData = getProjectsData()[projectId] || {};
  return projectData;
};

export const setProjectLayersState = ({
  projectId,
  newState
}: ChangeStorageDataInterface): void => {
  const data = getProjectsData();
  data[projectId] = newState;
  saveProjectsData(data);
};

export const deleteStoredProject = ({ projectId }: ProjectParamsInterface) => {
  const data = getProjectsData();
  delete data[projectId];
  saveProjectsData(data);
};

export const updateState = ({
  projectId,
  path,
  updatedState
}: UpdateNestedParamInterface): void => {
  const currentState = getProject({ projectId });
  const newState = updateNested(currentState, path, updatedState);
  setProjectLayersState({ projectId, newState });
};

export const deleteState = ({
  projectId,
  path,
  keyToDelete
}: DeleteNestedParamInterface) => {
  const currentState = getProject({ projectId });
  const newState = deleteNested(currentState, path, keyToDelete);
  setProjectLayersState({ projectId, newState });
};

export const setSensorsLayersState = ({
  projectId,
  updatedState
}: ChangeSeparateProjectValueInterface): void =>
  setProjectLayersState({
    projectId,
    newState: {
      ...getProject({ projectId }),
      ...updatedState
    }
  });

export const setActiveLayerPointsState = ({
  projectId,
  updatedState
}: ChangeSeparateProjectValueInterface): void =>
  updateState({
    projectId,
    path: [LayerAlias.MANUAL, UnitTypes.POINT],
    updatedState
  });

export const setHazardZonesState = ({
  projectId,
  updatedState
}: ChangeSeparateProjectValueInterface): void =>
  updateState({
    projectId,
    path: [LayerAlias.MANUAL, "hazard-zones"],
    updatedState
  });

export const setPolygonVisibilityState = ({
  projectId,
  updatedState
}: ChangeSeparateProjectValueInterface): void =>
  updateState({
    projectId,
    path: [LayerAlias.MANUAL, UnitTypes.POLYGON],
    updatedState
  });
